module.exports = __webpack_public_path__ + "static/img/qcjg1.18dee38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qcjg1.png
// module id = c768
// module chunks = 1